export const Loader = () => (
  <svg width="1em" height="1em" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10.0003 2.29175L10.0001 5.20841M10.0003 14.7917V17.7084M2.29175 10.0007H5.20841M14.7917 10.0007H17.7084M4.54965 4.54929L6.61186 6.61186M13.3885 13.3881L15.4509 15.4505M4.54988 15.4511L6.61227 13.3887M13.3887 6.61227L15.4511 4.54988"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default Loader
